import { useTranslation } from 'react-i18next'
import { ContentSection } from '@/features/settings/components/content-section'
import { AuthInterfaceLanguageSelect } from '@/features/auth/auth-interface-language-select'

export function LanguageSettingsPage() {
  const { t } = useTranslation('common')

  return (
    <ContentSection
      title={t('settings.language')}
      desc={t('settings.languageDescription')}
    >
      <AuthInterfaceLanguageSelect />
    </ContentSection>
  )
}
